import { GoogleMap, MarkerF, useJsApiLoader } from '@react-google-maps/api';
import { type GoogleMapBaseProps } from '../../types';

export const MyGoogleMap = ({ width, height, markerCoordinates, mapCenterCoordinate }: GoogleMapBaseProps) => {
  const googleMapWrapperStyle = {
    width,
    height,
  };

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyABxrrZ1QBFYY_-O8QibIWNPaFDNs56DoE',
  });
  const zoom = 16;

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {isLoaded ? (
        <GoogleMap mapContainerStyle={googleMapWrapperStyle} center={mapCenterCoordinate} zoom={zoom}>
          {markerCoordinates.map((coordinate) => (
            <MarkerF key={coordinate.lat} position={coordinate} />
          ))}
        </GoogleMap>
      ) : (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <></>
      )}
    </>
  );
};
